import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import type { CircularProgressbarProps } from "react-circular-progressbar/dist/types";

import SuccessCircleIcon from "$/lib/icons/SuccessCircleIcon";
import { cn } from "$/lib/utils/functions/misc.functions";

type Props = Partial<CircularProgressbarProps> & {
  value: number;
  className?: string;
  isLoading?: boolean;
};

const ProfileCircularProgressBar = ({ value, className, isLoading }: Props) => {
  if (isLoading) {
    return (
      <div className={cn("h-10 w-10 font-bold", className)}>
        <CircularProgressbar
          value={0}
          text=""
          strokeWidth={10}
          styles={{
            ...buildStyles({
              pathColor: "#D1D5DB",
              trailColor: "#E5E7EB",
            }),
          }}
        />
      </div>
    );
  }

  const ComponentToShow =
    value >= 100 ? (
      <SuccessCircleIcon className={cn("h-10 w-10 text-[#00D9A5]", className)} />
    ) : (
      <div className={cn("h-10 w-10 font-semibold", className)}>
        <CircularProgressbar
          value={value}
          text={`${value.toFixed(0)}%`}
          strokeWidth={10}
          styles={{
            ...buildStyles({
              textSize: "26px",
              pathColor: `#FFAB76`,
              textColor: "#1C1B26",
              trailColor: "#FFE8D4",
            }),
            // ✅ AJOUT : Centrage parfait du texte
            text: {
              fill: "#1C1B26",
              fontSize: "26px",
              fontWeight: 600,
              dominantBaseline: "central", // Centrage vertical parfait
              textAnchor: "middle", // Centrage horizontal (déjà présent par défaut)
            },
          }}
        />
      </div>
    );
  return ComponentToShow;
};

export default ProfileCircularProgressBar;
